import { useSelector } from 'react-redux';
import { TRootState } from 'store/index';

const useSidebarSelector = () => {
    return useSelector((state: TRootState) => state.sidebar);
};

export default useSidebarSelector;
